import React from "react";
import "./index.scss";
import { ErrorPageIcon } from "../../assets/images/svg/svg";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div>
        <ErrorPageIcon />
      </div>
      <div className="error-code">404</div>
      <div className="message">This page could not be found</div>
    </div>
  );
};

export default NotFound;


